import axios from "axios";
import { titleCaseToCamelCase } from "utils/titleCaseToCamelCase";

import { BASE_URL } from "./constants";

const setHttpHeaders = () => {
  axios.defaults.headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

const responseInterceptor = () => {
  axios.interceptors.response.use(response => {
    if (response.data) response.data = titleCaseToCamelCase(response.data);

    return response.data;
  });
};

export default function initializeAxios() {
  axios.defaults.baseURL = BASE_URL;
  setHttpHeaders();
  responseInterceptor();
}
